module.exports = __webpack_public_path__ + "img/rating-ico-4.0a7a2b33.png";